
import * as Yup from 'yup';
import dayjs from "dayjs";

export const getInitialApplicationData = (UserDetails: any) => {
    return {
        application_date: dayjs(),
        application_category: "",
        application_subcategory: "",
        before_cmrf_assistance: "false",
        other_scheme_applied: "false",
        aadhar_no: "",
        patient_name: "",
        patient_email: "",
        patient_contact: "",
        patient_family_number: "",
        gender: "",
        patient_date_of_birth: dayjs().add(-22, "years"),
        village_name: "",
        pin_code: "",
        hospital_id: '',
        tri_party_uuid: '',
        project_uuid: '',
        annual_income: "",
        is_panelled: true,
        other_hospital_name: "",
        doctor_team_number: "",
        additional_Amount: '',
        estimated_medical_cost: '',
        approved_medical_cost: '',
        medical_comment: "",
        vip_category: "",
        vip_name: "",
        vip_letter_date: dayjs(),
        vip_letter_number: "",
        vip_letter_file: null,
        income_certificate: null,
        hospital_estimate: null,
        other_documents: null,
        adhar_card: null,
        ration_card: null,
        vip_letter_file_url: '',
        income_certificate_url: '',
        hospital_estimate_url: '',
        other_documents_url: '',
        adhar_card_url: '',
        ration_card_url: '',
        fund_dignosis_report_file: null,
        patient_photo: null,
        supportive_document: [] as Array<File | string>,
        fund_dignosis_report_file_url: '',
        patient_photo_url: '',
        supportive_document_urls: [] as string[],
        cm_remarks: "",
        subject: "",
    }
};
export const CreateApplicationValidationSchema = Yup.object({
    patient_name: Yup.string().required("Full Name is required").matches(/^[a-zA-Z\s.]+$/, "Full Name can only contain letters and spaces"),
    patient_email: Yup.string().trim().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address").notRequired().nullable().optional(),
    patient_date_of_birth: Yup.date().required("Date of Birth is required"),
    patient_contact: Yup.string().matches(/^\d{10}$/, "Invalid mobile number").required("Mobile number is required"),
    patient_family_number: Yup.string().matches(/^\d{10}$/, "Invalid mobile number").required("Family Member Mobile number is required"),
    annual_income: Yup.number(),
    aadhar_no: Yup.string().matches(/^\d{12}$/, "Invalid Aadhar number").required("Aadhar number is required"),
    pin_code: Yup.string().matches(/^\d{6}$/, "Invalid PIN code").required("Pin Code is required"),
    hospital_id: Yup.string().required("Hospital selection is required"),
    doctor_team_number: Yup.string().matches(/^\d{10}$/, "Invalid mobile number").required("Doctor Mobile number is required"),
    estimated_medical_cost: Yup.number().nullable().notRequired(),
    approved_medical_cost: Yup.number().optional(),
    medical_comment: Yup.string().optional(),
    income_certificate: Yup.mixed().test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }).nullable(),
    hospital_estimate: Yup.mixed().test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }).nullable(),
    adhar_card: Yup.mixed().required('Aadhar card  is required').test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }),
    ration_card: Yup.mixed().required('Ration card is required').test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }),
    other_documents: Yup.mixed().test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }).nullable(),
    fund_dignosis_report_file: Yup.mixed().test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; }).nullable(),
    patient_photo: Yup.mixed().test('fileSize', 'File must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; }).test('fileType', 'Only image allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type.startsWith('image/'); }).nullable(),
    supportive_document: Yup.array().of(
        Yup.mixed()
            .test('fileSize', 'Each file must be 5MB or less', (value) => { if (!value || typeof value === 'string') return true; return (value as File).size <= 5 * 1024 * 1024; })
            .test('fileType', 'Only PDF allowed', (value) => { if (!value || typeof value === 'string') return true; return (value as File).type === 'application/pdf'; })
    ).nullable()
});


export const mapApplicationDataToFormik = (data: any = {}) => ({
    application_date: data.application_date ? dayjs(data.application_date) : dayjs(),
    application_category: data.application_category ?? "",
    application_subcategory: data.application_subcategory ?? "",
    before_cmrf_assistance: String(data.before_cmrf_assistance ?? "false"),
    other_scheme_applied: String(data.other_scheme_applied ?? "false"),
    aadhar_no: data.aadhar_no ?? "",
    patient_name: data.patient_name ?? "",
    patient_email: data.patient_email ?? "",
    patient_contact: data.patient_contact_no ?? "",
    patient_family_number: data.patient_family_number ?? "",
    gender: data.gender_name ?? "",
    patient_date_of_birth: data.DOB ? dayjs(data.DOB) : data.dob ? dayjs(data.dob) : dayjs().add(-22, "years"),
    village_name: data.village_name ?? "",
    pin_code: data.pincode ?? "",
    hospital_id: data.hospital_id ? String(data.hospital_id) : "",
    project_uuid: data.project_uuid ?? "",
    tri_party_uuid: data.tri_party_uuid ?? "",
    annual_income: data.annual_income ?? "",
    is_panelled: data.is_panelled ?? true,
    other_hospital_name: data.other_hospital_name ?? "",
    doctor_team_number: data.doctor_team_number ?? "",
    additional_Amount: data.additional_amount ?? "",
    estimated_medical_cost: data.estimated_medical_cost ?? "",
    approved_medical_cost: data.approved_medical_cost ?? "",
    medical_comment: data.medical_comment ?? "",
    vip_category: data.vip_category ?? "",
    vip_name: data.vip_name ?? "",
    vip_letter_date: data.vip_letter_date ? dayjs(data.vip_letter_date) : dayjs(),
    vip_letter_number: data.vip_letter_number ?? "",
    vip_letter_file: null,
    income_certificate: getFileFromDocuments(data.beneficiaries_document, "income_certificate"),
    hospital_estimate: getFileFromDocuments(data.beneficiaries_document, "hospital_estimate"),
    other_documents: getFileFromDocuments(data.beneficiaries_document, "other_documents"),
    adhar_card: getFileFromDocuments(data.beneficiaries_document, "adhar_card"),
    ration_card: getFileFromDocuments(data.beneficiaries_document, "ration_card"),
    vip_letter_file_url: getFileFromDocuments(data.beneficiaries_document, "vip_letter_file"),
    income_certificate_url: getFileFromDocuments(data.beneficiaries_document, "income_certificate"),
    hospital_estimate_url: getFileFromDocuments(data.beneficiaries_document, "hospital_estimate"),
    other_documents_url: getFileFromDocuments(data.beneficiaries_document, "other_documents"),
    adhar_card_url: getFileFromDocuments(data.beneficiaries_document, "adhar_card"),
    ration_card_url: getFileFromDocuments(data.beneficiaries_document, "ration_card"),
    fund_dignosis_report_file: getFileFromDocuments(data.beneficiaries_document, "fund_dignosis_report_file"),
    patient_photo: getFileFromDocuments(data.beneficiaries_document, "patient_photo"),
    supportive_document: getAllFilesFromDocuments(data.beneficiaries_document, "supportive_document"),
    fund_dignosis_report_file_url: getFileFromDocuments(data.beneficiaries_document, "fund_dignosis_report_file"),
    patient_photo_url: getFileFromDocuments(data.beneficiaries_document, "patient_photo"),
    supportive_document_urls: getAllFilesFromDocuments(data.beneficiaries_document, "supportive_document"),
    cm_remarks: data.cm_remarks ?? "",
    subject: data.subject ?? "",
});

const getFileFromDocuments = (docs: any[] = [], type: string) => {
    if (!Array.isArray(docs)) return null;
    const doc = docs.find((d) => d?.document_type === type && d?.document_path);
    return doc ? doc.document_path : null;
};

const getAllFilesFromDocuments = (docs: any[] = [], type: string): string[] => {
    if (!Array.isArray(docs)) return [];
    return docs
        .filter((d) => d?.document_type === type && d?.document_path)
        .map((d) => d.document_path as string);
};
